// import { getDictApi } from '@/api/common/public'
import { ENRYPT_KEY, isOS } from '@/utils/constant'
import CryptJS from 'crypto-js'
import { isArray } from 'lodash-es'
import FingerPrint from '@fingerprintjs/fingerprintjs'
import i18n from '@/lang'
import getPageTitle from '@/utils/get-page-title'
import vue from '@/main'
import { getEnvObj } from '@/utils/env'
import store from '@/store/index'
import qs from 'qs'

// import { render } from '@ibu/feedback'
/**
 * @param funcs 多个函数
 * @returns 将多个函数从右到左串联起来
 */
export const compose = (...funcs) => {
  // 没有传入函数则原样返回
  if (!funcs) {
    return args => args
  }
  if (funcs.length === 1) {
    return funcs[0]
  }
  return funcs.reduce((f1, f2) => (...args) => f1(f2(...args)))
}

export const uuid = () => {
  var d = new Date().getTime()
  var uuid = 'xxxxxxxxxxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
  return uuid
}

export function getHashParameters() {
  var arr = (location.hash || '').replace(/^#/, '').split('&')
  if (arr.length === 1) {
    return arr[0]
  } else {
    let str = ''
    for (var i = 0; i < arr.length; i++) {
      if (arr[i].indexOf('?') > -1) {
        const arr2 = arr[i].split('?')
        str = arr2[0]
      }
    }
    return str
  }
}

export const getHuanXinUrl = (lang) => {
  let url = ''
  switch (lang) {
    case 'zh-CN':
      url = 'https://kefu.sf.global/webim/im.html?configId=da680710-1acc-403e-b61b-094c89555a99'
      break
    case 'ja-JP':
      url = 'https://kefu.sf.global/webim/im.html?configId=d1effe21-6bcb-4af8-b6f6-9f28f023fdfd'
      break
    case 'ko-KR':
      url = 'https://kefu.sf.global/webim/im.html?configId=c419b1e3-48ff-4588-8b77-fd88509270e7'
      break
    default:
      url = 'https://kefu.sf.global/webim/im.html?configId=3aa10c40-3bec-44ab-94f7-23ba7109051e'
      break
  }
  return url
}

/**
 * 删除URL中指定search参数,会将参数值一起删除
 * @param {string} url 地址字符串
 * @param {array} aParam 要删除的参数key数组，如['name','age']
 * @return {string} 返回新URL字符串
 */
export const editUrl = (url, aParam) => {
  aParam.forEach(item => {
    const fromindex = url.indexOf(`${item}=`) // 必须加=号，避免参数值中包含item字符串
    if (fromindex !== -1) {
      // 通过url特殊符号，计算出=号后面的的字符数，用于生成replace正则
      const startIndex = url.indexOf('=', fromindex)
      const endIndex = url.indexOf('&', fromindex)
      const hashIndex = url.indexOf('#', fromindex)

      let reg
      if (endIndex !== -1) { // 后面还有search参数的情况
        const num = endIndex - startIndex
        reg = new RegExp(`${item}=.{${num}}`)
        url = url.replace(reg, '')
      } else if (hashIndex !== -1) { // 有hash参数的情况
        const num = hashIndex - startIndex - 1
        reg = new RegExp(`&?${item}=.{${num}}`)
        url = url.replace(reg, '')
      } else { // search参数在最后或只有一个参数的情况
        reg = new RegExp(`&?${item}=.+`)
        url = url.replace(reg, '')
      }
    }
  })
  const noSearchParam = url.indexOf('=')
  if (noSearchParam === -1) {
    url = url.replace(/\?/, '') // 如果已经没有参数，删除？号
  }
  return url
}

// 浏览器默认语言是否是日语或韩语，true是当前浏览器语言是日语或韩语，false为其他语言
export function langIsBelong(arr = ['ja', 'ko']) {
  const lang = getBrowserDefaultLang()
  return arr.indexOf(lang) > -1
}

// 获取浏览器配置语言
export function getBrowserDefaultLang() {
  const lang = navigator.userLanguage || window.navigator.language
  return lang.toLowerCase()
}

// element-ui的tabs页签页组件在使用vue-i18n切换语言后，按钮宽度发生变化之后定位不准确解决方案
export function resetTabActivePosition(vue, $el) {
  vue.$nextTick(() => {
    var activeEl = $el.querySelector('.el-tabs__item.is-active')
    var lineEl = $el.querySelector('.el-tabs__active-bar')
    var style = getComputedStyle(activeEl)
    var pl = style.paddingLeft.match(/\d+/)[0] * 1
    var pr = style.paddingRight.match(/\d+/)[0] * 1
    var w = style.width.match(/\d+/)[0] * 1
    lineEl.style.transform = 'translateX(' + (activeEl.offsetLeft + pl) + 'px)'
    lineEl.style.width = (w - pl - pr) + 'px'
  })
}

// 判断国家是否属于流向配置的国家，
export function isTrue(list = [], code, key = 'key') {
  let f = false
  list.forEach(e => {
    if (e[key] === code) {
      f = true
    }
  })
  return f
}

/**
   * 传入对象返回url参数
   * @param {Object} data {a:1}
   * @returns {string}
   */
function getParam(data) {
  let url = ''
  for (var k in data) {
    if (data.hasOwnProperty(k)) {
      const value = data[k] !== undefined ? data[k] : ''
      url += `&${k}=${encodeURIComponent(value)}`
    }
  }
  return url ? url.substring(1) : ''
}

/**
   * 将url和参数拼接成完整地址
   * @param {string} url url地址
   * @param {Json} data json对象
   * @returns {string}
   */
export function setUrl(url, data) {
  // 看原始url地址中开头是否带?，然后拼接处理好的参数
  return `${url}${url.indexOf('?') < 0 ? '?' : ''}${getParam(data)}`
}

// 这个是用来获取当前时间戳的
export function now() {
  return +new Date()
}

function evil(fn) {
  var Fn = Function // 一个变量指向Function，防止有些前端编译工具报错
  return new Fn('return ' + fn)()
}

// 修改url中的参数的值
export function replaceParamVal(paramName, replaceWith) {
  var oUrl = location.href.toString()
  // eslint-disable-next-line no-eval
  var re = evil('/(' + paramName + '=)([^&]*)/gi')
  if (oUrl.indexOf(paramName) > -1) {
    location.href = oUrl.replace(re, paramName + '=' + replaceWith)
  } else {
    location.href = `${oUrl}&${paramName}=${replaceWith}`
  }
  // console.log(location.href)
  // return location.href
}

/**
* 获取url中的所有参数对象
* @returns {object}
*/
export function getHtmlParams(url) {
  url = url || location.href
  var paramObj = {}
  try {
    var pindex = url.indexOf('?')
    if (pindex > 0) {
      var params = url.substring(pindex + 1)
      var paramArr = params.split('&')
      for (var i = 0; i < paramArr.length; i++) {
        var kv = paramArr[i].split('=')
        const kvIndex = kv[1].indexOf('#')
        if (kv[0] === 'lang' && kvIndex > -1) {
          paramObj[kv[0]] = kv[1].substring(0, kvIndex)
        } else if (['from', 'redirectUrl'].includes(kv[0]) && kv[1] !== '#') {
          paramObj[kv[0]] = getRealUrl(kv[1])
        } else if (kv[1] !== '#') {
          paramObj[kv[0]] = decodeURI(kv[1])
        }
      }
    }
  } catch (e) {
    console.log(e)
  }
  return paramObj
}

function getRealUrl(encodedUrl) {
  let decoded = encodedUrl
  let previous

  do {
    previous = decoded
    try {
      // 尝试解码一次
      decoded = decodeURIComponent(decoded)
      // 检查解码后的字符串是否是有效的 URL
      new URL(decoded) // 关键：如果能解析为 URL，立即终止
      return encodeURIComponent(decoded)
    } catch (e) {
      // 解码后的字符串无法解析为 URL，继续尝试解码
    }
  } while (decoded !== previous)

  // 如果完全无法解码，返回原始值
  return encodeURIComponent(decoded)
}
/**
* 获取url中的参数方法
* @param {string} variable
* @returns {string}
*/
export function getUrlKey(name, url) {
  var paramObj = getHtmlParams(url)
  return paramObj[name]
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}
/**
 * @param {Object} obj 要重置的对象
 * @param {Array} trg 指定要重置对应中的具体参数 默认为空数组 非必输
 * @param {String} trgVal 指定要重置的值 默认为空字符串 非必输
 * @returns {Object} 返回原对象
 */
export function resetObjVal({ obj, trg = [], trgVal = '' }) {
  if (trg.length) {
    trg.forEach(item => {
      if (obj.hasOwnProperty(item)) {
        obj[item] = trgVal
      }
    })
  } else {
    for (const key in obj) {
      obj[key] = trgVal
    }
  }
  return obj
}
/**
 *  为提供的链接添加域名
 * @param {String} url 要拼接的地址
 * @returns {Object} 返回完整url
 */
export function getUrl(url) {
  // 原先的
  // // let BASE = ''
  // // if (process.env.NODE_ENV === 'development') {
  // //   BASE = 'http://iuop.sit.sf-express.com'
  // // } else {
  // const BASE = window.location.protocol + '//' + window.location.host
  // // }
  // 修改，zkl，调试证件上传使用
  const obj = getEnvObj()
  return obj.SSO_LOGIN_URL + url
}

/**
 *  格式化国家地区信息
 * @param {String} str 国家地区字符
 * @returns {Object} 返回国家地区参数
 */
export function formatCountry(str) {
  // console.log(str)
  const arr = String(str).split('&')
  if (arr.length === 1) arr[0] = null
  const obj = {
    // countryName: arr[0] || '',
    countryCode: arr[0] || '',
    phoneCode: arr[1] || ''
  }
  return obj
}

/**
 *  去除首尾空格，仅支持字符串和一层对象
 * @param {Object | String} val 任意对象或字符串
 * @param {Array} key  需要去除首位空格的属性
 * @returns {Object} 去除首尾空格后的对象或字符串
 */
export function simpleTrim(val, keyWords) {
  if ((typeof val !== 'string' && val.toString() !== '[object Object]') || (keyWords && !Array.isArray(keyWords))) throw new Error('参数错误') // 检测参数类型
  let result
  if (typeof val === 'string') {
    result = val.trim()
  } else if (keyWords) {
    result = jsonKeyTrim(val, keyWords)
  } else {
    result = jsonTrim(val)
  }
  return result
}
function jsonTrim(val) {
  return JSON.parse(JSON.stringify(val, (key, value) => {
    switch (true) {
      case typeof value === 'undefined':
        return null
      case typeof value === 'string':
        return value.trim()
      default:
        return value
    }
  }))
}
function jsonKeyTrim(val, keyWords) {
  const obj = JSON.parse(JSON.stringify(val, (key, value) => {
    switch (true) {
      case typeof value === 'undefined':
        return null
      case key && checkArrayKey(key, keyWords):
        return value.trim()
      default:
        return value
    }
  }))
  return obj
}

/**
 *  查询数组里是否包含特定值
 * @param key 任意类型的特性值
 * @param {Array} keyWords 待查询数组
 * @returns {Boolean} 是否包含
 */
export function checkArrayKey(key, keyWords) {
  if (!Array.isArray(keyWords)) throw new Error('参数错误')
  let result = false
  keyWords.forEach(item => {
    if (item === key) {
      result = true
    }
  })
  return result
}

const AESUtil = {
  /**
     * AES 加密
     * @param _content 待加密内容
     * @param _key aesKey,
     * @return 返回经 BASE64 处理之后的密文
     */
  encrypt: function(_content, _key = ENRYPT_KEY) {
    // 先以 UTF-8 编码解码参数 返回 any 类型
    try {
      const content = CryptJS.enc.Utf8.parse(_content)
      const aesKey = CryptJS.enc.Utf8.parse(_key)

      // 加密
      const encrypted = CryptJS.AES.encrypt(content, aesKey, {
        mode: CryptJS.mode.ECB,
        padding: CryptJS.pad.Pkcs7
      })
      // console.log(encrypted)
      return CryptJS.enc.Base64.stringify(encrypted.ciphertext)
    } catch (e) {
      console.log(e)
    }
  },

  /**
     * AES 解密
     * @param：_content 待解密的内容[Base64处理过的]
     * @param：解密用的 AES key
     * @param: 初始化向量
     * @return 返回以 UTF-8 处理之后的明文
     */
  decrypt: function(_content, _key = ENRYPT_KEY) {
    try {
      const aesKey = CryptJS.enc.Utf8.parse(_key)

      // 解密
      const decrypted = CryptJS.AES.decrypt(_content, aesKey, {
        mode: CryptJS.mode.ECB,
        padding: CryptJS.pad.Pkcs7
      })
      // console.log(decrypted)
      return decrypted.toString(CryptJS.enc.Utf8)
    } catch (e) {
      return ''
    }
  }
}

export {
  AESUtil
}

/**
 * 用途：获取下拉框label值
 * @param {strOrNum} 下单框绑定的值
 * @param {arr} 下拉框对应的option的值
 * @param {value} 'element-UI对应的value值 '
 * @param {label} 'element-UI对应的label值 '
 */
export function getLabelText(strOrNum = '', arr = [], value = 'key', label = 'value') {
  let text = ''
  arr.forEach(item => {
    if (item[value] === strOrNum) {
      text = item[label]
    }
  })
  return text
}
/**
 * 用途：过滤value值对应的key，得到key-value对象
 * @param {mark} 'mark' 查询依据的值
 * @param {arr} 下拉框对应的option的值
 * @param {value} 'element-UI对应的value值 '
 * @param {key} 'element-UI对应的key值 '
 */
export function filterKeyAndValObj(mark = '', arr = [], value = 'value', key = 'key') {
  const obj = {}
  arr.forEach(item => {
    if (item[value] === mark) {
      obj[value] = mark
      obj[key] = item[key]
    }
  })
  return obj
}
/**
 * 用途：防抖会解决input实时输入去搜索，频繁请求接口的问题
 * @param {fn} 防抖后触发的方法
 * @param {delay} 延时器的时间
 */
export function debounce(fn, wait) {
  let timeout = null
  wait = wait || 600
  return function() {
    const that = this
    if (timeout !== null) clearTimeout(timeout)
    timeout = setTimeout(() => {
      fn.apply(that)
    }, wait)
  }
}

/**
 * 用途：根据国家二字码获取对应二字码+手机区号组合（用&连接）
 * @param {arr} 全量国家列表
 * @param {code} 国家二字码
 */
export function getPhoneVal(arr = [], code = '') {
  let str = ''
  // console.log(arr)
  arr.forEach(el => {
    if (el.countryCode === code) {
      str = `${el.countryCode}&${el.phoneCode}`
    }
  })
  return str
}
// 处理较大数字运用了科学计算法，需转换为数字
export function bigNumberToFixed(x) {
  var e
  if (Math.abs(x) < 1.0) {
    e = parseInt(x.toString().split('e-')[1])
    if (e) {
      x *= Math.pow(10, e - 1)
      x = '0.' + (new Array(e)).join('0') + x.toString().substring(2)
    }
  } else {
    e = parseInt(x.toString().split('+')[1])
    if (e > 20) {
      e -= 20
      x /= Math.pow(10, e)
      x += (new Array(e + 1)).join('0')
    }
  }
  return x
}
/**
 * 用途：数字截取N位
 * @param {oldVal} 截取前值
 * @param {cutLen} 截取长度
 */
export function cutNumberLength(oldVal, cutLen) {
  var string = oldVal + ''
  var newString
  if (string.length > cutLen) {
    if (string.includes('.')) {
      if (string.slice(0, cutLen).indexOf('.') === cutLen) {
        newString = string.slice(0, cutLen - 1)
      } else {
        newString = string.slice(0, cutLen)
      }
    } else {
      newString = string.slice(0, cutLen)
    }

    return newString
  } else {
    return oldVal
  }
}
/**
 * 用途：数字截取到小数点第N位
 * @param {oldVal} 截取前值
 * @param {floatLen} 截取小数位数
 */
export function cutFloatToN(oldVal, floatLen) {
  let string
  string = bigNumberToFixed(oldVal)
  if ((string + '').indexOf('.') !== -1 && (string + '').split('.')[1].length > floatLen) {
    // 截取到小数点第3位，不四舍五入
    string = (string + '').substring(0, (string + '').indexOf('.') + floatLen + 1)
  }
  return string
}

/**
 * 用途：对象数组去重
 * @param {arr} 需要去重的对象数组
 * @param {key} 需要判断去重条件的值
 */
export function uniqueObjArray(arr, key) {
  if (!Array.isArray(arr)) throw new Error('参数错误')
  const obj = {}
  // const newArr = []
  // for (var i = 0; i < arr.length; i++) {
  //   if (!obj[arr[i][key]]) {
  //     newArr.push(arr[i])
  //     obj[arr[i][key]] = true
  //   }
  // }
  arr = arr.reduce((item, next) => {
    if (!obj[next[key]]) {
      obj[next[key]] = true
      item.push(next)
    }
    return item
  }, [])
  return arr
  // return newArr
}

/**
 * 用途：获取当前日期（年月日时分秒）
 * @param {symbols} 年月日的分隔符，默认分隔符是 -
 * @param {isSecond} 是否需要秒，默认不需要
 */
export function getNowTime(symbols = '-', isSecond = false) {
  const date = new Date()
  const year = date.getFullYear()
  let month = date.getMonth() + 1
  month = month < 10 ? ('0' + month) : month
  let day = date.getDate()
  day = day < 10 ? ('0' + day) : day
  let hour = date.getHours()
  hour = hour < 10 ? ('0' + hour) : hour
  let minutes = date.getMinutes()
  minutes = minutes < 10 ? ('0' + minutes) : minutes
  let second = date.getSeconds()
  second = second < 10 ? ('0' + second) : second
  let time = year + symbols + month + symbols + day + ' ' + hour + ':' + minutes
  if (isSecond) {
    time = time + ':' + second
  }
  return time
}

export const findPatentValue = (array, value, valueName = 'value', childrenName = 'children') => {
  if (!value || !Array.isArray(array)) return []
  const result = []
  let valid = false
  const seek = (array, value) => {
    let parentValue = ''
    const up = (array, value, lastValue) => {
      array.forEach(v => {
        const val = v[valueName]
        const child = v[childrenName]
        if (val === value) {
          valid = true
          parentValue = lastValue
          return
        }
        if (child && child.length) up(child, value, val)
      })
    }
    up(array, value)
    if (parentValue) {
      result.unshift(parentValue)
      seek(array, parentValue)
    }
  }
  seek(array, value)
  return valid ? [...result, value] : []
}

export const treeToList = list => {
  const result = []
  for (const item of list) {
    result.push(item)
    if (item.children && item.children.length !== 0) {
      result.push(...treeToList(item.children))
    }
  }
  return result
}

export const enableValidate = (list, key, val) => {
  return list.every(item => item[key] === val)
}

export const hasChild = (target, childAlias = 'children') => {
  return isArray(target[childAlias]) && target[childAlias].length > 0
}

// 从地址栏url获取lang，更新页面国际化
export const updatePageLanguage = () => {
  const lang = getUrlKey('lang')
  i18n.locale = lang
  document.title = getPageTitle(vue.$route.meta.title)
}

// 获取设备ID
export const generateVisitorId = () => {
  return new Promise(resolve => {
    const fPromise = FingerPrint.load()
    fPromise.then(fp => fp.get()).then(res => {
      resolve(res.visitorId || '')
    })
  })
}

export const getRandomStr = (length = 32) => {
  const s = []
  var hexDigits = '0123456789abcdefghijklmnopqrstuvwxyz'
  for (var i = 0; i < length; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  const uuid = s.join('')
  return uuid
}

export const jumpToOwt = (token, toCnOwt) => {
  const ENV = window._global.ENV
  if (isOS() && !toCnOwt) {
    window.open(`https://www.abxexpress.com.my`)
  } else {
    const countryCode = store.getters.site.siteConfig.country
    if (ENV === 'PRD') {
      window.open(`https://www.sf-international.com/core-service/web/newUser/redirect/link?token=${token}&country=${countryCode}&lang=${store.getters.language}`)
    } else {
      window.open(`https://owt-uat.sf-international.com:9886/core-service/web/newUser/redirect/link?token=${token}&country=${countryCode}&lang=${store.getters.language}`)
    }
  }
}

export function initFeedback(cbFn) {
  const app = document.getElementById('feedback') || ''
  const language = store.getters.language
  // 验证码国际化
  const lang = {
    'zh-CN': 'zh_CN',
    'zh-HK': 'zh_HK',
    'en': 'en_US',
    'ja-JP': 'ja_JP',
    'ko-KR': 'ko_KR',
    'th-TH': 'th_TH',
    'vi-VN': 'vi_VN'
  }
  const env = window['ENV'] // sit-cn uat-cn uat-os sit-sg uat-sg prd-cn prd-sg prd-os
  // cn-sit,local,sg-sit,sg-pro,cn-pro
  let param = ''
  if (env === 'prd-os') {
    param = 'sg-pro'
  } else if (env === 'prd-cn') {
    param = 'cn-pro'
  } else if (env === 'prd-sg') {
    param = 'sg-pro'
  } else if (env === 'uat-os') {
    param = 'sg-sit'
  } else if (env === 'uat-sg') {
    param = 'sg-sit'
  } else if (env === 'prd-sg') {
    param = 'sg-pro'
  } else if (env === 'uat-cn') {
    param = 'cn-sit'
  } else if (env === 'uat-us') {
    param = 'us-sit'
  } else if (env === 'prd-us') {
    param = 'us-pro'
  } else {
    param = 'cn-pro'
  }
  window.$iee_feedback.init({
    moduleCode: 'feedback_6', // 必填 模块编码
    lang: lang[language], // 选填 语言标识 简体 zh-CN 繁体zh-HK 英文en
    cbFn: cbFn,
    sysCode: 'icas', // 必填 系统编码
    // channelCode: 'ICAS_PC_Web', // 必填 渠道编码
    container: app, // 必填 挂载容器
    isShowMyfeedback: false,
    sceneCode: '', // 选填 场景编码
    env: param
  })
}

export function isFromTawian() {
  return localStorage.getItem('isFromTainwan') || '0'
}

/**
 * 来源Url添加国家
 */
export function concateFromUrlWithSiteCode(urlFrom) {
  try {
    if (urlFrom.indexOf('siteCountryCode') !== -1) {
      return urlFrom
    }
    const countryCode = getUrlKey('siteCountryCode') ?? store.getters.siteCode // url上源系统编码
    const url = decodeURIComponent(urlFrom)
    let extension = ''
    if (url.indexOf('?') === -1) {
      extension = url.endsWith('?') ? `siteCountryCode=${countryCode}` : `?siteCountryCode=${countryCode}`
    } else {
      extension = url.endsWith('&') ? `siteCountryCode=${countryCode}` : `&siteCountryCode=${countryCode}`
    }
    console.log('jump url', url + extension, urlFrom + encodeURIComponent(extension))
    return urlFrom + encodeURIComponent(extension)
  } catch (e) {
    return urlFrom
  }
}

export function setPrimaryThemeColors(color) {
  // 创建一个 <style> 标签
  const style = document.createElement('style')

  // 添加样式规则，包括 !important 来确保优先级
  style.innerHTML = `
   .el-button--primary {
     background-color: ${color} !important;
     border-color: ${color} !important;
   }
   .el-tabs__active-bar {
     background-color: ${color} !important;
   }
     .linkColorO {
     color: ${color} !important;
     }
.el-checkbox__input.is-checked .el-checkbox__inner {
background-color: ${color} !important;
}
.el-form-item__error {
     color: ${color} !important;
}
 `
//  .el-checkbox__inner {
//   background-color: ${color} !important;
//   }

  // 将 <style> 标签添加到 <head> 中
  document.head.appendChild(style)

  // 获取所有带有 'el-button--primary' 类的元素
  // const buttons = document.getElementsByClassName('el-button--primary')

  // // 将HTMLCollection转换为数组，然后循环修改每个元素的背景颜色
  // Array.from(buttons).forEach(button => {
  //   button.style.backgroundColor = color
  // })
  // Array.from(buttons).forEach(button => {
  //   button.style.borderColor = color
  // })

  // const tabs = document.getElementsByClassName('el-tabs__active-bar')

  // // 将HTMLCollection转换为数组，然后循环修改每个元素的背景颜色
  // Array.from(tabs).forEach(button => {
  //   button.style.backgroundColor = color
  // })
}

export function filterScopeName(scopeName) {
  if (scopeName === 'OSMY') {
    scopeName = 'OS'
  }
  return scopeName
}

export const handleRedirectUrl = (url, token, sysCode, lang) => {
  const baseUrl = url.split('?')[0]
  const queryObjs = url.split('?').length > 0 ? qs.parse(url.split('?')[1], { ignoreQueryPrefix: true }) : {}
  queryObjs['sf_token'] = token
  if (lang) { queryObjs['lang'] = lang }
  queryObjs['sysCode'] = sysCode
  const urlRes = baseUrl + qs.stringify(queryObjs, { addQueryPrefix: true })
  // debugger
  return urlRes
}

export const handleRedirectUrlWithoutSF = (url, token, sysCode, lang) => {
  const baseUrl = url.split('?')[0]
  const queryObjs = url.split('?').length > 0 ? qs.parse(url.split('?')[1], { ignoreQueryPrefix: true }) : {}
  queryObjs['token'] = token
  if (lang) { queryObjs['lang'] = lang }
  queryObjs['sysCode'] = sysCode
  const urlRes = baseUrl + qs.stringify(queryObjs, { addQueryPrefix: true })
  // debugger
  return urlRes
}

// Determine if the current window is in an iframe
export const isInIframe = () => {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}
